import classes from './WorkflowStepper.module.css';

export type WorkflowStepState = 'current' | 'completed' | 'upcoming';

export type WorkflowStep = {
  id: string;
  label: string;
  state: WorkflowStepState;
};

export function WorkflowStepper({
  steps,
  ariaLabel = 'Workflow steps',
}: {
  steps: WorkflowStep[];
  ariaLabel?: string;
}) {
  return (
    <nav className={classes.root} aria-label={ariaLabel}>
      <ol className={classes.list}>
        {steps.map((step, index) => {
          const stateClass =
            step.state === 'current'
              ? classes.itemCurrent
              : step.state === 'completed'
                ? classes.itemCompleted
                : undefined;
          return (
            <li
              key={step.id}
              className={[classes.item, stateClass].filter(Boolean).join(' ')}
              data-testid={`workflow-step-${step.id}`}
              data-state={step.state}
            >
              <span className={classes.index}>{index + 1}</span>
              <span className={classes.label}>{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
